(function () {
  'use strict';

  function initCoverflow(root) {
    if (!root || root.dataset.smjCoverflowBound === 'true') return;
    root.dataset.smjCoverflowBound = 'true';

    var track = root.querySelector('[data-smj-coverflow-track]');
    if (!track) return;

    var slides = Array.from(track.querySelectorAll('[data-smj-coverflow-slide]'));
    if (!slides.length) return;

    var prevBtn = root.querySelector('[data-smj-coverflow-prev]');
    var nextBtn = root.querySelector('[data-smj-coverflow-next]');
    var total = slides.length;
    var active = Math.floor(total / 2);
    var timer = null;
    var autoplayMs = parseInt(root.dataset.autoplay || '0', 10);

    function wrap(i) {
      return ((i % total) + total) % total;
    }

    function offsetFromActive(index) {
      var raw = index - active;
      if (raw > total / 2) raw -= total;
      if (raw < -total / 2) raw += total;
      return raw;
    }

    function paint() {
      var visible = [];

      slides.forEach(function (slide, index) {
        var offset = offsetFromActive(index);
        slide.setAttribute('data-offset', String(offset));

        if (Math.abs(offset) > 2) {
          slide.classList.add('is-hidden-slot');
          slide.setAttribute('aria-hidden', 'true');
          return;
        }

        slide.classList.remove('is-hidden-slot');
        slide.setAttribute('aria-hidden', offset === 0 ? 'false' : 'true');
        visible.push({ slide: slide, offset: offset });
      });

      visible.sort(function (a, b) {
        return a.offset - b.offset;
      });

      visible.forEach(function (item) {
        track.appendChild(item.slide);
      });

      slides.forEach(function (slide) {
        if (slide.classList.contains('is-hidden-slot')) {
          track.appendChild(slide);
        }
      });
    }

    function go(step) {
      active = wrap(active + step);
      paint();
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayMs || total < 2) return;
      timer = setInterval(function () {
        go(1);
      }, autoplayMs);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        go(-1);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        go(1);
        startAutoplay();
      });
    }

    function isMobileLayout() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    slides.forEach(function (slide) {
      slide.addEventListener('click', function (e) {
        if (isMobileLayout()) return;
        var index = slides.indexOf(slide);
        if (index < 0 || index === active) return;
        e.preventDefault();
        active = index;
        paint();
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!isMobileLayout()) paint();
      }, 150);
    });

    paint();
    startAutoplay();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-smj-coverflow]').forEach(initCoverflow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-smj-coverflow]').forEach(function (el) {
      el.dataset.smjCoverflowBound = 'false';
    });
    boot(event.target);
  });
})();
